module.exports = __webpack_public_path__ + "img/empty-pic.051f5d53.png";